<template>
  <div class="hint-center" id="setPushid">
    <!-- 设置推送方式 -->
    <el-dialog title="设置推送方式" :visible.sync="hintShow" width="20%" v-if="hintShow" id="hintShow">
      <div>
        <div style="margin-bottom:20px;">
          <el-radio v-model="pushradio" label="1" class="radio-check-nromal" value="1">每小时推送一次，一天24次</el-radio>
        </div>
        <div>
          <el-radio v-model="pushradio" label="2" class="radio-check-nromal" value="2">
            自定义推送时间
            <span style="color:#e90e24">*</span>
            <el-select v-model="pushTime"   placeholder="请选择"  size="mini">
              <el-option
                v-for="item in hourTime"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setPushTime" class="confire" type="confire_btn" size="small">确 定</el-button>
        <el-button size="small" type="cancel_blue" @click="hintShow=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 批量设置通知人 -->
    <el-dialog
      title="批量设置通知人"
      :visible.sync="noticeShow"
      width="23%"
      v-if="noticeShow"
      class="setNotice-digole"
    >
      <div>
        <div class="flex-between" style="align-items:center;">
          <div>通知人微信</div>
          <el-select
            multiple
            placeholder="请选择"
            size="small"
            style="margin:0 8px;"
            v-model="selectPeople"
          >
            <el-option
              v-for="item in wechatNoticeList"
              :key="item.openid"
              :label="item.remark||item.nickname"
              :value="item.openid"
            ></el-option>
          </el-select>
          <div style="color:#108cee;width:100px;" @click="newAdd">新增通知人</div>
        </div>
        <el-image :src="wechatUrl" v-if="showWechatUrl" class="ecord"></el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="confire" type="confire_btn" size="small" @click="setPushNoticePeople">确 定</el-button>
        <el-button size="small" type="cancel_blue" @click="noticeShow=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 设置限价 -->
    <el-dialog
      title="设置限价"
      :visible.sync="priceShow"
      width="35%"
      v-if="priceShow"
      class="priceShow"
    >
      <div>
        <div class="flex-center">
          <el-table
            header-row-class-name="data-table-header-style"
            :data="skuTableData"
            style="width: 100%"
          >
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="date" label="SKU名称">
              <template slot-scope="scope">
                <div class="flex-start flex-vereical-center">
                  <div class="sku-img" v-show="scope.row.skuStatus==='1'&&scope.row.skuPhoto">
                    <img
                      :src="scope.row.skuPhoto"
                      v-show="scope.row.skuPhoto"
                      style="width:100%;height:100%;"
                    />
                    <div class="disable-img" v-show="scope.row.skuStatus==='1'&&scope.row.skuPhoto"></div>
                  </div>
                  <span
                    class="two_ellipsis"
                    :style="{color:scope.row.skuStatus==='1'?'#999':''}"
                  >{{scope.row.skuTitle}}</span>
                  <div class="remove-normal" @click="delSkuSingle(scope.row.id)">-</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="限价标准" width="230">
              <template slot-scope="scope">
                <div class="flex-start">
                  <span style="color:#e90e24">*</span>
                  <el-input
                    size="small"
                    style="margin:0 3px;"
                    type="number"
                    :disabled="scope.row.skuStatus==='1'?true:false"
                    v-model="skuPrices[scope.$index].prices"
                    min='1'
                    step="0.01"
                    @input='onput(scope.$index)'
                  ></el-input>
                  <span
                    style="color:#52c41a"
                    v-show="scope.row.skuUpdate==='1'"
                  >新上架</span>
                  <span style="color:#999999" v-show="scope.row.skuStatus==='2'">已下架</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="confire" type="confire_btn" size="small" @click="checkLimitPirce">确 定</el-button>
        <el-button size="small" type="cancel_blue" @click="priceShow=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 提示-->
    <elementHint
      ref="hintCommon"
      :main="hint.main"
      :main2="hint.main2"
      :redMain="hint.redMain"
      @hintConfire="hintConfire"
    ></elementHint>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import wxBindingComponent from "../../../../components/wxComponent/wxBindingComponent.vue";
import elementHint from "@/components/dataTable/elementHint"; //提示

export default {
  data() {
    return {
      selectPeople: "",
      showWechatUrl: false,
      pushTime: "",
      hourTime:[],
      hintShow: false,
      pushradio: "1",
      noticeShow: false,
      priceShow: false,
      skuTableData: [],
      skuPrices: [],
      hint: {
        main: "",
        main2: "",
        redMain: ""
      }
    };
  },
  computed: {
    ...mapGetters(["moniotorLinkList", "wechatNoticeList"]),
    ...mapState({
      userInfo: state => state.serviceReport.userinfo
    })
  },
  components: { elementHint ,wxBindingComponent},
  mounted() {
    this.reqGetbmcwx();
    this.pushNoticeType();
    this.gethourTime()
  },
  methods: {
    ...mapActions([
      "reqgetMonitorItemList",
      "monitorNoticeList",
      "reqGetbmcwx"
    ]),
    onput(index){
      let e=this.skuPrices[index].prices
      if(e<=0){
         this.skuPrices[index].prices=''
      }else{
         this.skuPrices[index].prices= e.match(/^\d*(\.?\d{0,2})/g)[0].replace(/\-/g,'')
      }
      console.log( this.skuPrices[index].prices)
    },
    gethourTime(){
      for(let i=0;i<25;i++){
        i<10?this.hourTime.push(`0${i}:00`):this.hourTime.push(`${i}:00`)
      }
    },
    pushNoticeType() {
      fetchGet("hcm/monitorLink/pushNoticeType").then(res => {
        if (res.status === "10000") {
          if (res.data === "perhour") {
            this.pushradio = "1";
          } else {
            this.pushradio = "2";
            this.pushTime = res.data;
          }
        }
      });
    },
    setPushNoticePeople() {
      fetchGet("hcm/monitorLink/setPushNoticePeople", {
        ids: this.noticeOpenid,
        openids: this.selectPeople.join(",")
      }).then(res => {
        if (res.status === "10000") {
          this.$message.success("成功");
          this.noticeShow=false
          this.reqgetMonitorItemList(this.moniotorLinkList.search);
        }
      });
    },
    // 新增(扫码绑定)
    newAdd() {
      this.$refs.childWxBinding.getbmcwx('m',this.userInfo.bid)
    },
    setPushTime() {
      if (this.pushradio === "1") {
        let data = {
          noticeType: "perhour"
        };
        this.setPushNoticeType(data);
      } else {
        //自定义
        let data = {
          noticeType: this.pushTime
        };
        this.setPushNoticeType(data);
      }
    },
    setPushNoticeType(data) {
      fetchGet("hcm/monitorLink/setPushNoticeType", data).then(res => {
        if (res.status === "10000") {
          this.$message.success("设置成功");
          this.hintShow = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    checkLimitPirce() {
      let prices = [];
      let ids = [];
      let goOn = true;
      for (let i = 0; i < this.skuPrices.length; i++) {
        if (!this.skuPrices[i].prices && this.skuPrices[i].skuStatus !== "1") {
          this.$message.error("请填写限价标准");
          goOn = false;
          break;
        } else if (
          this.skuPrices[i].prices &&
          this.skuPrices[i].skuStatus !== "1"
        ) {
          ids.push(this.skuPrices[i].ids);
          prices.push(this.skuPrices[i].prices);
        }
      }
      if (goOn && ids.length > 0) {
        fetchGet("hcm/monitorLink/priceStandard", {
          ids: ids.join(","),
          prices: prices.join(",")
        }).then(res => {
          if (res.status === "10000") {
            this.reqgetMonitorItemList(this.moniotorLinkList.search);
          }
        });
        this.priceShow = !this.priceShow;
      }
    },
    changShow() {
      this.hintShow = !this.hintShow;
    },
    changeNoticeShow(id) {
      this.noticeOpenid = id;
      // this.monitorNoticeList();
      this.noticeShow = !this.noticeShow;
    },
    changePriceShow(index) {
      this.priceShow = !this.priceShow;
      this.skuIndex = index;
      this.skuTableData = this.moniotorLinkList.tableData[index].skuList;
      let arr = [];
      this.skuTableData.forEach(item => {
        arr.push({
          ids: item.id,
          prices: item.checkPrice,
          skuStatus: item.skuStatus
        });
      });
      this.skuPrices = arr;
    },
    hintConfire() {
      if (this.type === 1) {
        //删除sku
        this.delSkuhttp();
      }
    },
    delSkuhttp() {
      //单独删除
      fetchGet("hcm/monitorLink/deleteNewMonitorSku", {
        skuid: this.delskuId
      }).then(res => {
        if (res.status === "10000") {
          this.$message.success("操作成功");
          this.reqgetMonitorItemList(this.moniotorLinkList.search).then(() => {
            this.skuTableData = this.moniotorLinkList.tableData[
              this.skuIndex
            ].skuList;
            this.$refs.hintCommon.closeifsee();
          });
        }
      });
    },
    delSkuSingle(id) {
      this.delskuId = id;
      this.hint.main = "确认删除该链接吗？";
      this.hint.main2 = "删除后该链接的监控数据会被";
      this.hint.redMain = "彻底删除";
      this.type = 1;
      this.$refs.hintCommon.ifsee();
    }
  }
};
</script>
<style lang="scss">
@import "src/style/tableCommon";
#setPushid {
  .setNotice-digole {
    .el-input__inner,
    .el-select {
      padding: 5px;
    }
  }

  #hintShow {
    .el-date-editor {
      width: 40%;
    }
  }
  .ecord {
    width: 100px;
    height: 100px;
    float: right;
  }
  .el-dialog__footer {
    clear: both;
  }
  .priceShow {
    .el-input {
      width: 115px;
    }
    .el-table {
      height: 300px;
      overflow-y: auto;
    }
  }
  .sku-img {
    width: 43px;
    height: 43px;
    margin-right: 5px;
    position: relative;
  }
  .disable-img {
    position: absolute;
    background: #999999;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    opacity: 0.5;
  }
}
</style>
